export const ProfileAISummaryWidgetStateKey = {
  CONTENT: 'content',
  GENERATE: 'generate',
  SKELETON: 'skeleton',
}

export const PROFILE_AI_SUMMARY_WIDGET_WARNING = {
  emailIsArchived: 'email_is_archived',
  emailIsNotSatisfyingSummaryRequirement:
    'email_is_not_satisfying_summary_requirement',
  insufficientTokens: 'insufficient_tokens',
  notSummarizable: 'not_summarizable',
  someAttachmentsNotProcessed: 'some_attachments_not_processed',
  temporaryUnavailable: 'temporary_unavailable',
}
